import Button from "../../Custom/Button/Button";
import NotificationList from "./NotificationList";
import "./notification.css";
import bellIcon from "../../../picture/Bell.png";
import plusIcon from "../../../picture/Plus.png";
import { useGlobalContext } from "../../../Context/Context";
import NotificationBar from "./NotificationBar";
import { useEffect, useRef, useState } from "react";
import CustomSlider from "./CustomSlider";
import CustomList from "./CustomList";
import sendImg from "../../picture/send.png";
import { compareAsc } from "date-fns";
import axios from "axios";

const Notification = ({ selectedCompany }) => {
  const setCorrectNotifications = () => {};

  const [notifications, setNotifications] = useState([]);
  const [addNotification, setAddNotification] = useState(false);
  const [currentActive, setCurrentActive] = useState(0);
  const [currentNotification, setCurrentNotification] = useState({
    id: 0,
    name: "",
    location: "",
    user: "Zikica Petkovic",
    startTime: "",
    endTime: "",
    date: "",
    description: "",
    comment: [],
    notifyUsers: [],
    alarms: [],
    alarmTime: "",
  });
  const [currentSelectedNotification, setCurrentSelectedNotification] =
    useState(null);
  const [notificationsList, setNotificationsList] = useState([]);

  const [isEditing, setIsEditing] = useState(false);
  const textAreaRef = useRef();
  const socket = useRef();
  const { loggedUser, apiKey } = useGlobalContext();
  const { baseUrl } = useGlobalContext();

  const isFromSliderRef = useRef();

  const handleSetNotifications = async () => {
    if (isEditing) {
      const newNotifications = notifications.map((notification) => {
        if (notification.id === currentNotification.id)
          return currentNotification;
        else return notification;
      });

      console.log(currentNotification);
      let locationUpd = {};
      if (currentNotification.location.length !== undefined) {
        currentNotification.location.forEach((element) => {
          if (element.forNotify) locationUpd = element;
        });
      } else {
        locationUpd = currentNotification.location;
      }

      console.log(locationUpd);
      console.log(currentNotification.date);
      const year = currentNotification.date.getFullYear();
      const month = currentNotification.date.getMonth() + 1;
      const day = currentNotification.date.getDate();
      const date = year + "-" + month + "-" + day;
      console.log(new Date(date));
      console.log(currentNotification);

      const newAlarms = currentNotification.alarms.map((alarm) => {
        console.log(alarm);
        const yearAlarm = alarm.getFullYear();
        const monthAlarm = alarm.getMonth() + 1;
        const dayAlarm = alarm.getDate();
        const hoursAlarm = alarm.getHours();
        const minutesAlarm = alarm.getMinutes();
        const dateAlarm =
          yearAlarm +
          "-" +
          monthAlarm +
          "-" +
          dayAlarm +
          "T" +
          hoursAlarm +
          ":" +
          minutesAlarm +
          ":00";
        return dateAlarm;
        console.log(new Date(dateAlarm));
      });
      console.log(currentNotification.alarms);
      const sendData = {
        id: parseInt(currentNotification.id), //
        company_id: selectedCompany.company_id, //
        user_id: loggedUser.id, //
        user: loggedUser.name,
        api_key: apiKey, //
        name: currentNotification.name, //
        location: locationUpd,
        startTime: currentNotification.startTime,
        endTime: currentNotification.endTime,
        date: date,
        description: currentNotification.description,
        comment: currentNotification.comment,
        notifyUsers: currentNotification.notifyUsers,
        alarms: newAlarms,
        alarmTime: currentNotification.alarmTime,
        isFromSlider: currentNotification.isFromSlider,
      };

      /* company_id: parseInt(selectedCompany.company_id),
              user_id: loggedUser.id,
              api_key: apiKey,
              notif_name: nNotification.name,
              location: location,
              startTime: nNotification.startTime,
              endTime: nNotification.endTime,
              date: date,
              description: nNotification.description,
              comment: nNotification.comment,
              notifyUsers: nNotification.notifyUsers,
              alarms: newAlarms,
              alarmTime: nNotification.alarmTime,
              isFromSlider: nNotification.isFromSlider, */

      try {
        const response = await axios.post(
          `${baseUrl}/notifications/updateNotification.php`,
          sendData
        );
        const { data } = response;
        console.log(response);
        if (data.status === 200) {
          setNotifications(newNotifications);

          if (socket.current.readyState === WebSocket.OPEN) {
            socket.current.send(
              JSON.stringify({
                ...sendData,
                type: "notification",
                isUpdate: true,
              })
            );
            console.log("Notification sent to WebSocket:", {
              ...sendData,
              type: "notification",
              isUpdate: true,
            });
          } else {
            console.warn("WebSocket connection not open.");
          }
          setAddNotification(false);
          setCurrentNotification({
            name: "",
            location: "",
            user: "",
            startTime: "",
            endTime: "",
            date: "",
            description: "",
            comment: [],
            notifyUsers: [],
            alarms: [],
            alarmTime: "",
          });
          setNotificationsList([]);
          setIsEditing(false);
          setAddNotification(false);
        }
      } catch (error) {
        if (error.status === 404) {
          console.log(error);
        }
      }
    } else {
      let isFound = notificationsList.find((n) => n.alarms.length === 0);
      console.log("Pronadjeno", isFound);
      if (isFound) return;
     
      if(notificationsList[0]=== undefined) return
      console.log("Izvrsava se",notificationsList[0])
      
      if (
        notificationsList[0].startTime === "" &&
        notificationsList[0].endTime === ""
      )
        return;

        
     
      const responses = [];
      notificationsList.map(async (nNotification) => {
        let location = currentNotification.location;
        /*if (nNotification.location.length !== undefined) {
          nNotification.location.forEach((element) => {
            if (element.forNotify) location = element;
          });
        } else {
          location = nNotification.location;
        }*/

        const year = nNotification.date.getFullYear();
        const month = nNotification.date.getMonth() + 1;
        const day = nNotification.date.getDate();
        const date = year + "-" + month + "-" + day;
        const newAlarms = nNotification.alarms.map((alarm) => {
          console.log(alarm);
          const yearAlarm = alarm.getFullYear();
          const monthAlarm = alarm.getMonth() + 1;
          const dayAlarm = alarm.getDate();
          const hoursAlarm = alarm.getHours();
          const minutesAlarm = alarm.getMinutes();
          const dateAlarm =
            yearAlarm +
            "-" +
            monthAlarm +
            "-" +
            dayAlarm +
            "T" +
            hoursAlarm +
            ":" +
            minutesAlarm +
            ":00";
          return dateAlarm;
        });
        try {
          const response = axios.post(
            `${baseUrl}/notifications/createNotification.php`,
            {
              company_id: parseInt(selectedCompany.company_id),
              user_id: loggedUser.id,
              api_key: apiKey,
              notif_name: nNotification.name,
              location: location,
              startTime: nNotification.startTime,
              endTime: nNotification.endTime,
              date: date,
              description: nNotification.description,
              comment: nNotification.comment,
              notifyUsers: nNotification.notifyUsers,
              alarms: newAlarms,
              alarmTime: nNotification.alarmTime,
              isFromSlider: nNotification.isFromSlider,
            }
          );

          responses.push(response);
        } catch (error) {
          if (error.status === 404) {
            console.log(error);
          }
        }
        console.log(nNotification);
      });
      const fullNotificationsList = await Promise.all(responses);

      const newFilteredData = notificationsList.map((item, index) => {
        return {
          ...item,
          user_id: loggedUser.id,
          id:
            fullNotificationsList[index].data.status === 200
              ? fullNotificationsList[index].data.id
              : 0,
        };
      });
      console.log(newFilteredData, notificationsList);

      newFilteredData.forEach((item) => {
        if (
          socket.current !== null &&
          socket.current !== undefined &&
          socket.current.readyState === WebSocket.OPEN
        ) {
          socket.current.send(
            JSON.stringify({ ...item, type: "notification", isUpdate: false })
          );
          console.log("Notification sent to WebSocket:", {
            ...item,
            type: "notification",
          });
        } else {
          console.warn("WebSocket connection not open.");
        }
      });

      const dataToSet = [...notifications, ...newFilteredData];

      console.log(dataToSet);
      setNotifications(dataToSet);

      setAddNotification(false);
      setCurrentNotification({
        name: "",
        location: "",
        user: "",
        startTime: "",
        endTime: "",
        date: "",
        description: "",
        comment: [],
        notifyUsers: [],
        alarms: [],
        alarmTime: "",
      });
    }
    isFromSliderRef.current = false;
    setIsEditing(false);
  };

  const handleAddNotification = () => {
    setAddNotification(!addNotification);
    setNotificationsList([]);
  };

  useEffect(() => {
    const fatchNotification = async () => {
      try {
        const { data } = await axios.post(
          `${baseUrl}/notifications/readNotificationsByCompanyId.php`,
          {
            company_id: selectedCompany.company_id,
            user_id: loggedUser.id,
            api_key: apiKey,
          }
        );
        console.log(data);
        if (data.status === 200) {
          console.log("Prosao");
          let currentNotification = data.data || [];
          console.log(currentNotification);
          let newCurrentNotification = currentNotification.map(
            (notification) => {
              let alarms = notification.alarms.map((alarm) => {
                return new Date(alarm);
              });
              let userName = notification.user.name;
              let location = notification.location;
              console.log(location);
              console.log("Izmena", alarms);
              return {
                ...notification,
                date: new Date(notification.date),
                alarms,
                user: userName,
              };
            }
          );
          console.log(newCurrentNotification);
          let corectNotification = newCurrentNotification.filter((current) => {
            const hours = current.startTime.split(":")[0];
            const minutes = current.startTime.split(":")[1];
            const date = current.date.setHours(hours, minutes, 0, 0);
            return compareAsc(date, new Date()) >= 0;
          });
          //treba dodati i vreme
          console.log(corectNotification);

          socket.current = new WebSocket(
            `ws://192.168.0.19:8080?profile_id=${loggedUser.id}&company_id=${selectedCompany.company_id}`
          ); // Update with your WebSocket server URL

          socket.current.onopen = function () {
            console.log("Connected to WebSocket server.");
          };

          setNotifications(corectNotification);
        }
      } catch (error) {
        if (error.status === 404) {
          console.log(error);
        }
      }
    };
    fatchNotification();

    return () => {
      /*socket.current.onClose = function () {
        console.log("Disconnected from WebSocket server.");
        // Optionally try to reconnect
      };*/
    };
  }, []);

  useEffect(() => {
    console.log("Poziva se on message not", socket);
    if (socket.current)
      socket.current.onmessage = function (event) {
        console.log(
          "Notification from server:",
          JSON.parse(event.data),
          notifications
        );
        const dataParse = JSON.parse(event.data);
        console.log(dataParse);
        if (dataParse.isUpdate) {
          const newdataParse = { ...dataParse, date: new Date(dataParse.date) };
          console.log(newdataParse);
          const newNotifications = notifications.map((item) => {
            if (parseInt(item.id) === parseInt(newdataParse.id)) {
              return newdataParse;
            } else {
              return item;
            }
          });

          console.log(newNotifications);
          setNotifications(newNotifications);
        } else {
          const dataParse = JSON.parse(event.data);
          if (parseInt(loggedUser.id) !== parseInt(dataParse.user_id)) {
            const newdataParse = {
              ...dataParse,
              date: new Date(dataParse.date),
            };

            let newNotifications = [...notifications, newdataParse];
            console.log(newNotifications);
            setNotifications(newNotifications);
          }
        }
      };
  }, [notifications]);

  console.log(selectedCompany, "Ovo je selektovana kompanija");
  return (
    <div
      className={
        selectedCompany.company_id !== null
          ? "wrapper-notification"
          : "wrapper-notification-profile"
      }
    >
      <div className="wrapper-notification-content">
        <NotificationList
          currentActive={currentActive}
          setCurrentNotification={setCurrentNotification}
          currentNotification={currentNotification}
          setIsEditing={setIsEditing}
          isEditing={isEditing}
          setAddNotification={setAddNotification}
          notifications={notifications}
          setNotificationsList={setNotificationsList}
          setCurrentSelectedNotification={setCurrentSelectedNotification}
        />
      </div>
      {selectedCompany.company_id !== null && (
        <div className="wrapper-bar">
          <div
            className="create-notification"
            onClick={() => handleAddNotification()}
          >
            <Button active={addNotification}>
              <div className="icon-notification">
                <img className="plus-icon" src={plusIcon} alt="" />
                <img src={bellIcon} alt="" />
              </div>
            </Button>
          </div>
        </div>
      )}

      {addNotification && (
        <NotificationBar
          setAddNotification={setAddNotification}
          currentActive={currentActive}
          setCurrentActive={setCurrentActive}
          notificationsList={notificationsList}
          currentNotification={currentNotification}
          setCurrentNotification={setCurrentNotification}
          handleSetNotifications={handleSetNotifications}
          setNotificationsList={setNotificationsList}
          isFromSliderRef={isFromSliderRef}
          setIsEditing={setIsEditing}
          currentSelectedNotification={currentSelectedNotification}
          isEditing={isEditing}
          selectedCompany={selectedCompany}
          notifications={notifications}
          setNotifications={setNotifications}
        />
      )}
    </div>
  );
};

export default Notification;
